import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_GIFTS,
  REQUEST_CREATE_MASTER_GIFTS,
  SET_MASTER_GIFTS,
  SUCCESS_CREATE_MASTER_GIFTS,
  ERROR_GET_MASTER_GIFTS,
  ERROR_CREATE_MASTER_GIFTS,
  SUCCESS_DELETE_MASTER_GIFTS,
  SUCCESS_UPDATE_MASTER_GIFTS,
  REQUEST_DELETE_MASTER_GIFTS,
  REQUEST_UPDATE_MASTER_GIFTS,
  ERROR_DELETE_MASTER_GIFTS,
  ERROR_UPDATE_MASTER_GIFTS,
} from "./giftcardsActionTypes";

function* requestMasterGifts(action: Record<string, any>): any {
  try {
    const result: any = yield call(getGiftsMaster);
    yield put({ type: SET_MASTER_GIFTS, payload: result.data.data });
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_GIFTS, payload: message });
  }
}

function* requestUpdateMasterTagGift(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterGifts,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_GIFTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_GIFTS, payload: message });
  }
}

function* requestDeleteMasterTagGift(action: Record<string, any>): any {
  try {
    yield call(deleteMasterGifts, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_GIFTS,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_GIFTS, payload: message });
  }
}

function* requestCreateMasterGifts(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterGifts, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_GIFTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_GIFTS, payload: message });
  }
}

export function getGiftsMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/template`,
    withCredentials: true,
  });
}

export function createMasterGifts(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/template`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterGifts(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/template/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterGifts(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/template/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const giftsMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_GIFTS, requestMasterGifts),
    takeLatest(REQUEST_CREATE_MASTER_GIFTS, requestCreateMasterGifts),
    takeLatest(REQUEST_UPDATE_MASTER_GIFTS, requestUpdateMasterTagGift),
    takeLatest(REQUEST_DELETE_MASTER_GIFTS, requestDeleteMasterTagGift),
  ]);
};

export default giftsMasterSaga;
